import * as React from "react";
import { useTranslation } from "hhn-commons";
import {
  LeftTabStyle,
  RightTabStyle,
  SwitchTabsWrapper,
  TabLabel,
  TabsWrapper,
} from "./SwitchTabs.style";
import { userTracking } from "../analytics/userTracking";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export enum SWITCH_TAB {
  LEFT = 0,
  RIGHT = 1,
}

export enum SWITCH_TAB_TYPE {
  MESSAGES = "Messages",
  ALERT = "Alert",
}

export const SwitchTabs = ({
  type,
  onTabValueChange,
}: {
  type: SWITCH_TAB_TYPE;
  onTabValueChange: (value: number) => void;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });
  const [currentTab, setCurrentTab] = React.useState<SWITCH_TAB>(
    SWITCH_TAB.LEFT,
  );
  const leftTabSelected = currentTab === SWITCH_TAB.LEFT;
  const rightTabSelected = currentTab === SWITCH_TAB.RIGHT;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
    onTabValueChange(newValue);

    // Track tab switch
    const tabLabel = newValue === SWITCH_TAB.LEFT
      ? (type === SWITCH_TAB_TYPE.ALERT ? "Pending" : "More")
      : (type === SWITCH_TAB_TYPE.ALERT ? "Sent" : "Less");

    userTracking.trackTabSwitch(type, tabLabel, newValue);
  };

  return (
    <SwitchTabsWrapper>
      <TabsWrapper
        value={currentTab}
        onChange={handleChange}
        aria-label={
          type === SWITCH_TAB_TYPE.ALERT
            ? "acknowledge type"
            : "patient chat details"
        }
      >
        <LeftTabStyle
          isCurrent={leftTabSelected}
          label={
            <TabLabel isCurrent={leftTabSelected}>
              {type === SWITCH_TAB_TYPE.ALERT
                ? tNs("acknowledgeType.pending")
                : tNs("patientChatDetails.more")}
            </TabLabel>
          }
          {...a11yProps(0)}
        />
        <RightTabStyle
          isCurrent={rightTabSelected}
          label={
            <TabLabel isCurrent={rightTabSelected}>
              {type === SWITCH_TAB_TYPE.ALERT
                ? tNs("acknowledgeType.sent")
                : tNs("patientChatDetails.less")}
            </TabLabel>
          }
          {...a11yProps(1)}
        />
      </TabsWrapper>
    </SwitchTabsWrapper>
  );
};
